"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortOption = void 0;
exports.sortOption = [
    {
        id: 1,
        name: 'Newest First',
        sort: { _id: -1 },
    },
    {
        id: 2,
        name: 'Oldest First',
        sort: { _id: 1 },
    },
];
